import { useMutation, useQuery } from "react-query";
import api from "../common/axios";
import { Endpoints } from "../common/constants";
import { reportError } from "../crashlytics";

export function useGetServices(departmentId) {
    return useQuery(
        [Endpoints.Services.GetServices, departmentId],
        () =>
            api
                .get(Endpoints.Services.GetServices + "?department_id=" + departmentId)
                .then((response) => response?.data?.data),
        {
            onError: (error) => {
                reportError("useGetServices: useQuery: onError: error", error);
            },
        }
    );
}

export function useGetAvailableTimeSlots(serviceId) {
    return useQuery(
        [Endpoints.Services.GetAvailableTimeSlots, serviceId],
        () =>
            api
                .get(
                    Endpoints.Services.GetAvailableTimeSlots + "?service_id=" + serviceId
                )
                .then((response) => response?.data?.data),
        {
            onError: (error) => {
                reportError(
                    "useGetAvailableTimeSlots: useQuery: onError: error",
                    error
                );
            },
        }
    );
}

export function useReserve() {
    return useMutation(
        ({ date, time, service_id }) =>
            api
                .post(Endpoints.Services.Reserve, {
                    date: date,
                    time: time,
                    service_id: service_id,
                })
                .then((response) => response?.data?.data),
        {
            onError: (error) => {
                reportError("useReserve: useMutation: onError: error", error);
            },
        }
    );
}

export function useReserveUpdate() {
    return useMutation(
        ({ appointment_id, client_name, client_cnp, client_phone, client_email_address , client_additional}) =>
            api
                .post(Endpoints.Services.ReserveUpdate, {
                    appointment_id: appointment_id,
                    client_name: client_name,
                    client_cnp: client_cnp,
                    client_phone: client_phone,
                    client_email_address: client_email_address,
                    client_additional: client_additional
                })
                .then((response) => response?.data?.data),
        {
            onError: (error) => {
                reportError("useReserveUpdate: useMutation: onError: error", error);
            },
        }
    );
}

export function useResendCode() {
    return useMutation(
        ({ appointment_id }) =>
            api
                .post(Endpoints.Services.ResendCode, {
                    appointment_id: appointment_id
                })
                .then((response) => response?.data),
        {
            onError: (error) => {
                reportError("useResendCode: useMutation: onError: error", error);
            },
        }
    );
}

export function useReserveConfirm() {
    return useMutation(
        ({ appointment_id, sms_code }) =>
            api
                .post(Endpoints.Services.ReserveConfirm, {
                    appointment_id: appointment_id,
                    sms_code: sms_code,
                })
                .then((response) => response?.data?.data),
        {
            onError: (error) => {
                reportError("useReserveConfirm: useMutation: onError: error", error);
            },
        }
    );
}

export function useSystemUpdatereservation() {
    return useMutation(
        ({ appointment_id, additional }) =>
            api
                .post(Endpoints.Services.SystemUpdatereservation + "/" + appointment_id, {
                    additional: additional
                })
                .then((response) => response?.data?.data),
        {
            onError: (error) => {
                reportError("useSystemUpdatereservation: useQuery: onError: error", error);
            },
        }
    );
}
